// extracted by mini-css-extract-plugin
export var barContainer = "_48-0";
export var extraThin = "_48-3";
export var fillBar = "_48-6";
export var fillContainer = "_48-4";
export var overflow = "_48-8";
export var overflowContainer = "_48-5";
export var regular = "_48-7";
export var thick = "_48-1";
export var thin = "_48-2";